import { useEffect, useState } from "react";

export const useDeferredEnabled = (
  enabled: boolean,
  delayMs: number,
): boolean => {
  const [deferredEnabled, setDeferredEnabled] = useState(
    enabled && delayMs <= 0,
  );

  useEffect(() => {
    if (!enabled) {
      setDeferredEnabled(false);
      return;
    }

    if (delayMs <= 0) {
      setDeferredEnabled(true);
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setDeferredEnabled(true);
    }, delayMs);

    return () => window.clearTimeout(timeoutId);
  }, [delayMs, enabled]);

  return deferredEnabled;
};
